import { PaginationData, QueryParams } from 'shared/types';
import request from '../../features/regions/services/requester/region.request';
import { CountryRegion } from 'shared/models';

const countryRegionService = {
  getRegions: (params: QueryParams) => request.get<PaginationData<CountryRegion>>('/country-regions', { params }),

  getOneRegion: (params: QueryParams) => request.get<CountryRegion>('/country-regions/find-one', { params }),
};

export default countryRegionService;
